import { render, staticRenderFns } from "./GalleryHotspot.vue?vue&type=template&id=c935acc8&scoped=true&"
import script from "./GalleryHotspot.vue?vue&type=script&lang=ts&"
export * from "./GalleryHotspot.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryHotspot.vue?vue&type=style&index=0&id=c935acc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c935acc8",
  null
  
)

export default component.exports